<template>
  <div v-if="isCountdownVisible" class="countdown-page" :class="{'countdown-page--big': isBigCounter}">
    <component
      class="countdown-page__wrap"
      :style="{'background-color': initialData.background_color}"
      :is="initialData.link ? 'a' : 'div'"
      :href="initialData.link || undefined"
    >
      <div class="countdown-page__title"
           :class="computedTimerTheme"
           v-if="isBigCounter"
           v-html="initialData.title"
      ></div>
      <img
        v-if="computedBackground"
        :src="computedBackground"
        class="countdown-page__background"
        alt="countdown background"
      >
      <img
        v-if="computedImg"
        :src="computedImg"
        class="countdown-page__image"
        alt="countdown image"
      >
      <div
        v-if="initialData.show_timer"
        class="countdown-page__timer-wrap"
        :style="{'background-color': initialData.background_color}"
      >
        <Timer
          v-if="initialData.end_date"
          class="countdown-page__timer"
          :is-countdown-on-page-small="!isBigCounter"
          :is-countdown-on-page-big="isBigCounter"
          :is-product-page="isBigCounter"
          :title="$t('count_expiration')"
          :deadline="initialData.end_date"
          :type="computedTimerTheme"
        />
      </div>
      <div v-if="!isBigCounter" class="countdown-page__users-counter users-counter" :class="{'users-counter--dark': computedUsersTheme === 'light', 'users-counter--light': computedUsersTheme === 'dark'}">
        <img :src="computedUsersTheme === 'light' ? '/img/countdown/eye-white.png' : '/img/countdown/eye-gray.png'" alt="icon" />
        <div class="users-counter__data">
          <p class="users-counter__data-content">{{ computedTranslation(config.total_users_online) }}</p>
          <p class="users-counter__data-title">{{ $t('users_online_now') }}</p>
        </div>
      </div>
    </component>
  </div>
</template>

<script>
import Timer from '@/components/promo-pages/Timer.vue'
import { mapState } from 'vuex'
import { wordFormatter } from '@/mixins/wordFormatter'

export default {
  name: 'CountdownPage',
  data () {
    return {
      windowWidth: window.innerWidth
    }
  },
  mixins: [wordFormatter],
  components: {
    Timer
  },
  props: {
    initialData: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  computed: {
    ...mapState({
      config: state => state.init.config
    }),
    isCountdownVisible () {
      return !!(this.initialData.start_date && this.initialData.end_date && new Date().getTime() <= this.initialData.end_date * 1000 && new Date().getTime() >= this.initialData.start_date * 1000)
    },
    isBigCounter () {
      return this.initialData.placement_type === 'sale_page_big'
    },
    computedTimerTheme () {
      if (this.initialData.theme === 'white') {
        return 'light'
      }
      return 'dark'
    },
    computedUsersTheme () {
      if (this.initialData.theme_users_quantity === 'white') {
        return 'light'
      }
      return 'dark'
    },
    computedImg () {
      if (this.windowWidth <= 798) {
        return this.initialData.image_mobile
      }
      if (this.windowWidth > 798 && this.windowWidth < 1130) {
        return this.initialData.image_768 || this.initialData.image_1100 || this.initialData.image_1400
      }
      if (this.windowWidth >= 1130 && this.windowWidth < 1430) {
        return this.initialData.image_1100 || this.initialData.image_1400
      }
      return this.initialData.image_1400
    },
    computedBackground () {
      if (this.windowWidth <= 798) {
        return this.initialData.background_image_mobile
      }
      if (this.windowWidth > 798 && this.windowWidth < 1130) {
        return this.initialData.background_image_768 || this.initialData.background_image_1100 || this.initialData.background_image_1400
      }
      if (this.windowWidth >= 1130 && this.windowWidth < 1430) {
        return this.initialData.background_image_1100 || this.initialData.background_image_1400
      }
      return this.initialData.background_image_1400
    }
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  },
  methods: {
    computedTranslation (value) {
      return this.wordFormatter(value, [
        this.$t('product_stats_users_1', { n: value }),
        this.$t('product_stats_users_2', { n: value }),
        this.$t('product_stats_users_3', { n: value })
      ])
    }
  }
}
</script>

<style lang="sass">
.countdown-page
  &__title
    position: relative
    z-index: 1
    font-size: 18px
    font-weight: 400
    order: 1
    line-height: 1
    margin-right: auto
    &.dark
      color: #fff
    +mmax(798)
      text-align: center
      margin: 0 auto 5px
    span
      font-size: 48px
      font-weight: 700
      +mmax(1430)
        font-size: 40px
      +mmax(1130)
        font-size: 30px
</style>
<style lang="sass" scoped>
.countdown-page
  padding: 0 15px
  border-radius: 7px
  overflow: hidden
  &--big
    overflow: visible
    .countdown-page
      &__timer-wrap
        order: 2
        +mmax(798)
          margin: 0 auto 20px
          width: auto
      &__image
        order: 3
        margin-left: 50px
        margin-right: 0
        +mmax(1430)
          margin-left: auto
        +mmax(798)
          order: -1
          margin: 35px auto 0
      &__wrap
        height: 120px
        padding: 0 0 0 60px
        +mmax(1430)
          padding: 0 0 0 40px
        +mmax(1130)
          padding: 0 0 0 20px
        +mmax(798)
          height: auto
          padding: 0
  &__image
    position: relative
    z-index: 1
    margin-right: auto
    +mmax(798)
      display: block
      margin: 0 auto 7px
  &__timer-wrap
    position: relative
    z-index: 1
    border-radius: 5px
    +mmax(798)
      width: 100%
      margin: 0 auto 13px
  &__background
    width: 100%
    height: 100%
    background-position: center
    background-repeat: no-repeat
    object-fit: cover
    position: absolute
    left: 0
    top: 0
  &__wrap
    position: relative
    display: flex
    align-items: center
    height: 80px
    padding: 0 25px
    +mmax(798)
      flex-direction: column
      height: 230px
      padding: 5px 15px 15px
.users-counter
  position: relative
  z-index: 1
  display: flex
  align-items: center
  justify-content: flex-start
  flex-flow: row nowrap
  align-self: center
  margin: 10px 0 10px 95px
  padding: 11px 15px
  border-radius: 7px
  background-color: #FFFFFF
  min-height: 60px
  min-width: 247px
  +mmax(1130)
    min-width: 175px
    margin: 10px 0 10px 20px
  +mmax(798)
    margin: auto auto 0
  +mmax(450)
    width: 100%
  &--light
    background-color: #fff
  &--dark
    background-color: #333
    .users-counter__data
      &-title
        color: #909090
      &-content
        color: #fff
  > img
    align-self: center
    +mmax(1130)
      display: none
    +mmax(798)
      display: block
  &__data
    display: flex
    flex-flow: column nowrap
    align-items: flex-start
    justify-content: center
    margin-left: 17px
    &-title
      font-size: 13px
      font-weight: 400
    &-content
      font-size: 16px
      font-weight: 500
    > p
      margin: 0
      white-space: nowrap

</style>
